import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ACTIONS_LIST } from '../data/actons-list';
import { ElementsService } from './elements.service';
import { isArray } from 'util';

@Injectable({
  providedIn: 'root'
})
export class UndoService {

  private _actionsList:Subject<any> = new Subject();
  private _currentActions: any = ACTIONS_LIST;
  actionsList$ = this._actionsList.asObservable();
  
  constructor(
    public elementsService: ElementsService
    ) { }
  

  get dataSource(): Subject<any> {
    return this._actionsList;
  }
  set dataSource(data: Subject<any>) {
    this._actionsList = data;
  }

  addAction(type:string,previousValue:{}){
    // console.log(previousValue)
    this._currentActions.actions.push({type:type,previousValue:previousValue})
    this._currentActions.state='push';
    
    this.dataSource.next(this._currentActions);
  }

  undo(){
    // console.log(this._currentActions.actions)
    if(this._currentActions.actions.length==0)
      return null;
    let action=this._currentActions.actions.pop()
    this._currentActions.state='undo';
    this.performUndo(action);
    this.dataSource.next(this._currentActions);
    return action;
  }

  performUndo(action){
    
    if(action.type=='addPoint'){
      if(action.previousValue.type=='DRAW-CONTOUR'){
        // console.log('perform undo')
        this.elementsService.removeElementPointById('contour',action.previousValue.layer,action.previousValue.id)
      }else{
        this.elementsService.removeElementPointById('zones',action.previousValue.layer,action.previousValue.id)
      }
    }else if(action.type=='movePoint'){
      if(action.previousValue.type=='DRAW-CONTOUR'){
        // console.warn(action)
        let layer=this.elementsService.getElementById('contour',action.previousValue.layer);
        if(isArray(action.previousValue.id))
          for(let i=0;i<action.previousValue.id.length;i++)
            layer.points[action.previousValue.id[i]]=action.previousValue.originalPosition
        else
          layer.points[action.previousValue.id]=action.previousValue.originalPosition

          for(let i=0;i<action.previousValue.otherPoints.length;i++){
            action.previousValue.otherPointsArray[action.previousValue.otherPoints[i].zone][action.previousValue.otherPoints[i].id]=action.previousValue.originalPosition
          }
        // console.log(action.previousValue)
      }else{
        // console.log('perform undo move')
        let layer=this.elementsService.getElementById('zones',action.previousValue.layer);
        if(isArray(action.previousValue.id))
          for(let i=0;i<action.previousValue.id.length;i++)
            layer.points[action.previousValue.id[i]]=action.previousValue.originalPosition
        else
          layer.points[action.previousValue.id]=action.previousValue.originalPosition
        // console.log(action.previousValue)

        for(let i=0;i<action.previousValue.otherPoints.length;i++){
          action.previousValue.otherPointsArray[action.previousValue.otherPoints[i].zone][action.previousValue.otherPoints[i].id]=action.previousValue.originalPosition
        }
        // this.elementsService.removeElementPointById('zones',action.previousValue.layer,action.previousValue.id)
      }

    }else if(action.type=='removePoint'){
      
      if(action.previousValue.type=='DRAW-CONTOUR'){
        let layer=this.elementsService.getElementById('contour',action.previousValue.layer);
        layer.points=action.previousValue.points.slice();
        // console.log(action)
          // for(let i=action.previousValue.points.length-1;i>=0;i--){
          //   layer.points.splice(action.previousValue.points[i].index, 0, action.previousValue.points[i].value);
          // }
        
      }else{
        let layer=this.elementsService.getElementById('zones',action.previousValue.layer);
        layer.points=action.previousValue.points.slice();
          // for(let i=action.previousValue.points.length-1;i>=0;i--){
          //   layer.points.splice(action.previousValue.points[i].index, 0, action.previousValue.points[i].value);
          // }
        
      }
    }else if(action.type=='removeZone'){
      this.elementsService.putZoneOnIndex(action.previousValue.zone,action.previousValue.index)
      // console.log(action)
    }
  }
}
